
import { Button } from "@/components/ui/button";
import { ArrowLeft, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const CookieHeader = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-golden-orange to-teedee-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center mb-6">
          <Button asChild variant="ghost" className="text-white hover:bg-white/20 mr-4">
            <Link to="/">
              <ArrowLeft className="h-5 w-5 mr-2" />
              Back to Home
            </Link>
          </Button>
        </div>
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Cookie className="h-16 w-16" />
          </div>
          <h1 className="text-5xl font-bold mb-6">Cookie Policy</h1>
          <p className="text-xl max-w-3xl mx-auto opacity-90">
            Learn about how Bobo & Teedee® uses cookies and similar technologies.
          </p>
          <p className="text-sm mt-4 opacity-75">Last updated: January 2025</p>
        </div>
      </div>
    </section>
  );
};

export default CookieHeader;
